// store/permission.js
import { asyncRouterMap, constantRouterMap } from '@/router'
import { fetchDomain, getAppMenuTree, getSelfApps } from '@/api/login'
import { Message } from 'element-ui'
import Cookies from 'js-cookie'
import store from '../index'

const lang = Cookies.get('language')

const filterOutRouterList = (appList) => {
  console.log('appList', appList)
}

// 从href中获取路由
const getRouteFromHref = (href) => {
  const match = href.match(/http[s]?:\/\/(.*?)([:\/]|$)/) || []
  const domain = match && match[0]
  href = href.split('?')[0].replace(domain, '/')
  return href
}

/**
 * route访问权限判断
 * route.hidden为true时，默认为可以访问，不与菜单树比较
 * @param  {Object}   route         单个路由对象
 * @param  {Array}    appMenuTree   菜单树
 * @param  {String}   domain        WEB对应的域名地址
 * @param  {String}   parentPath    父级路由地址
 * @return {Boolean}                当前用户是否有权限访问该路由
 */
const hasPermission = (route, appMenuTree, domain, parentPath) => {
  // console.log('route, appMenuTree,domain,parentPath',route, appMenuTree,domain,parentPath)
  if (route.hidden === true) {
    return true
  }
  if (appMenuTree.find(app => {
    const path = !parentPath ? route.path : route.path ? parentPath + '/' + route.path : parentPath
    if (path === getRouteFromHref(app.href, domain)) {
      route.meta && (route.meta.title = lang === 'en' ? app.enName : app.name)
    }
    // console.log(getRouteFromHref(app.href, domain).startsWith(path), app.href, domain, path)
    if (getRouteFromHref(app.href, domain).startsWith(path)) {
    // if (getRouteFromHref(app.href, domain)) {
      route.priority = app.priority
      return true
    }
    if (hasPermission(route, app.child, domain, parentPath)) {
      return true
    }
  })) {
    return true
  }
  return false
}

/**
 * router访问权限判断
 * @param  {Array}    routerList    路由数组
 * @param  {Array}    appMenuTree   菜单树
 * @param  {String}   domain        WEB对应的域名地址
 * @param  {String}   parentPath    父级路由地址
 * @return {Array}                  当前用户可访问的路由数组
 */
const filterRouterList = (routerList, appMenuTree, domain, parentPath) => {
  return routerList.filter(route => {
    if (route.children && route.children.length > 0) {
      route.children = filterRouterList(route.children, appMenuTree, domain, !parentPath ? route.path : route.path ? parentPath + '/' + route.path : parentPath)
    }
    if (hasPermission(route, appMenuTree, domain, parentPath)) {
      return true
    }
    return false
  })
}

const permission = {
  namespaced: true,
  state: {
    hasGotRouters: false,
    routers: constantRouterMap,
    addRouters: [],
    appList: [],
    menuData: [],
    domain: {}
  },
  mutations: {
    SET_MENUS: (state, menus) => {
      state.hasGotRouters = true
      state.menuData = menus
    },
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers.accessedRouters
      state.routers = constantRouterMap.concat(routers.accessedRouters)
      // state.menuData = routers.menuData
    },
    SET_APPS: (state, appList) => {
      state.appList = appList
    },
    SET_DOMAIN: (state, domain) => {
      Object.assign(state.domain, domain)
    }
  },
  actions: {
    GenerateRoutes({ commit, state, rootState }, data) {
      return new Promise((resolve, reject) => {
        Promise.all([getSelfApps()]).then(([response]) => {
          if (response.status === 200) {
            console.log(state,'aaaaa')
            // const domain = data.WEB
            // console.log(domain)
            // const appList = response.data.filter(item => item.code !== 'sg')     // 原来的获取所有应用的
            const appList = response.data.filter(item => item.code == state.domain.menuCode.user2b)         // 只获取 用户中心
            // const appList = response.data.filter(item => item.code == 'user') 
            commit('SET_APPS', appList)
            // commit('SET_DOMAIN', 'https://iam-org.alpha-dev.supaur.tech')
            // commit('SET_DOMAIN', domain)
            const menuApi = []
            appList.forEach(item => {
              // menuApi.push(getAppMenuTree({ appId: item.code }))       // 获取所有应用的menu
              menuApi.push(getAppMenuTree({ appId: state.domain.menuCode.user2b }))  // 只获取 用户中心的menu
              // menuApi.push(getAppMenuTree({ appId: 'user' }))  // 只获取 用户中心的menu
            })
            // console.log('菜单菜单',Promise.all(menuApi))
            // const appMenuTree = response.data
            // const accessedRouters = filterRouterList(asyncRouterMap, appMenuTree, domain, '')
            // commit('SET_ROUTERS', accessedRouters)
            return Promise.all(menuApi)
          } else {
            Message({
              message: response.message,
              type: 'error'
            })
          }
        }).then((responses) => {
          
          let menus = [...state.appList].filter((app) => app.isShow === 1).sort((a, b) => b.priority - a.priority)
          menus = menus.map((item, index) => {
            const res = responses[index]
            res && res.data && res.data.sort((a, b) => b.priority - a.priority)
            if (res.status === 200 || res.code === 'success') {
              let code = 'user'
              if (rootState.user && rootState.user.currentCategory === '08') {
                // 经销商
                code = 'userDealer'
              } else if (rootState.user && rootState.user.currentCategory === '09') {
                // 主机厂
                code = 'user'
              }
              // console.log(asyncRouterMap,110)
              // const accessedRouters = filterRouterList(asyncRouterMap, res.data, state.domain, '').sort((a, b) => b.priority - a.priority)
              const accessedRouters = filterRouterList(asyncRouterMap, res.data, state.domain, '')
              commit('SET_ROUTERS', { menuData: res.data, accessedRouters })
              // console.log('SET_ROUTERS',{ menuData: res.data,accessedRouters })
              return {
                ...item,
                children: accessedRouters
              }
            } else {
              Message({
                message: res.message,
                type: 'error'
              })
            }
          })
          console.log('menus',menus)
          commit('SET_MENUS', menus)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js